import type { VoucherState } from './voucherApi'

/**
 * KIM ISHLATDI / KIM SOTDI — «yozuv yo'q» va «hodisa bo'lmagan» AYRIM.
 *
 * =====================================================================
 * ⚠️ NIMA UCHUN BU FAYL BOR
 * =====================================================================
 * `voucher.activated_by` / `voucher.sold_by` ustunlari bazaga KEYIN
 * qo'shiladi. Ya'ni migratsiyagacha yozilgan kartalarda ular BO'SH
 * bo'ladi — va bo'sh qiymatni chiziqcha bilan chizish YOLG'ON bo'lardi:
 *
 *   · chiziqcha «hech kim ishlatmagan» deb o'qiladi;
 *   · haqiqat esa «karta ISHLATILGAN, lekin o'sha paytda kim ekanini
 *     yozadigan ustun yo'q edi».
 *
 * Ikkalasi bir xil ko'rinsa, operator aktivlashtirilgan kartani
 * «ishlatilmagan» deb sanaydi. Shuning uchun holat va vaqt belgisi
 * bo'yicha HODISA BO'LGANMI degan savol alohida hisoblanadi.
 *
 * ⚠️ `undefined` ham `null` kabi: backend maydonni umuman yubormasligi
 * mumkin (`voucherApi.ts` sxema izohi).
 */
export type VoucherActor =
  /** Hodisa BO'LMAGAN — chiziqcha */
  | { kind: 'none' }
  /** Hodisa BO'LGAN, aktyor yozilmagan — «noma'lum (eski yozuv)» */
  | { kind: 'unrecorded' }
  /** Aktyor yozilgan, nomi yo'q — qisqartirilgan nusxalanadigan id */
  | { kind: 'id'; id: string }
  | { kind: 'named'; name: string; id: string | null }

const clean = (raw: string | null | undefined): string | null => {
  const value = raw?.trim() ?? ''
  return value === '' ? null : value
}

/**
 * @param happened hodisaning O'ZI bo'lganmi (holat/vaqt belgisi bo'yicha)
 *
 * ⚠️ Nom bor bo'lsa `happened` GA QARALMAYDI: ma'lumotning o'zi
 * hodisadan kuchliroq dalil.
 */
export function voucherActor(
  happened: boolean,
  id: string | null | undefined,
  name: string | null | undefined,
): VoucherActor {
  const actorId = clean(id)
  const actorName = clean(name)
  if (actorName !== null) return { kind: 'named', name: actorName, id: actorId }
  if (actorId !== null) return { kind: 'id', id: actorId }
  return happened ? { kind: 'unrecorded' } : { kind: 'none' }
}

interface SoldSource {
  state: VoucherState
  soldAt: string | null
  soldBy?: string | null
  soldByName?: string | null
}

interface ActivatedSource {
  state: VoucherState
  activatedAt: string | null
  activatedBy?: string | null
  activatedByName?: string | null
}

/**
 * ⚠️ `ACTIVATED` karta sotuv belgisidan O'TMAGAN bo'lishi mumkin
 * (`NEW` dan to'g'ridan-to'g'ri ishlatilgan) — o'shanda «kim sotdi»
 * haqiqatan HODISASIZ, ya'ni chiziqcha. Shuning uchun bu yerda
 * `state === 'ACTIVATED'` sanalmaydi.
 */
export function voucherSeller(row: SoldSource): VoucherActor {
  return voucherActor(row.soldAt !== null || row.state === 'SOLD', row.soldBy, row.soldByName)
}

export function voucherActivator(row: ActivatedSource): VoucherActor {
  return voucherActor(
    row.activatedAt !== null || row.state === 'ACTIVATED',
    row.activatedBy,
    row.activatedByName,
  )
}
